import { React, useEffect, useState } from "react";
import horizontalSplit from "./utils/horizontalSplit";
import splitArray from "./utils/splitArray";
import "../../../../../../Components/Radio/Radio.css";
import {
  BsFillCircleFill,
  BsDiamondFill,
  BsFillSquareFill,
} from "react-icons/bs";
import { TbMinusVertical } from "react-icons/tb";
import { ImCross } from "react-icons/im";

const getParaIcon = (shape) => {
  switch (shape) {
    case "circle":
      return <BsFillCircleFill />;
    case "square":
      return <BsFillSquareFill />;
    case "diamond":
      return <BsDiamondFill />;
    case "lineVertical":
      return <TbMinusVertical />;
    case "cross":
      return <ImCross />;
    default:
      return <BsFillCircleFill />;
  }
};

const getAlignment = (text_alignment, columns) => {
  switch (text_alignment) {
    case "left":
      if (columns === 1) {
        return [" text-start "];
      } else if (columns === 2) {
        return [" text-start ", " text-start "];
      } else if (columns === 3)
        return [" text-start ", " text-start ", " text-start "];
      else if (columns === 4) {
        return [" text-start ", " text-start ", " text-start ", " text-start "];
      } else {
        return [" text-start ", " text-start ", " text-start ", " text-start ", " text-start ",];
      }

    case "justify":
      if (columns === 1) {
        return [" text-start "];
      } else if (columns === 2) {
        return [" text-start ", " text-end "];
      } else if (columns === 3)
        return [" text-start ", " text-center ", " text-end "];
      else if (columns === 4) {
        return [" text-start ", " text-start ", " text-end ", " text-end "];
      } else {
        return [" text-start ", " text-start ", " text-center ", " text-end ", " text-end ",];
      }

    case "right":
      if (columns === 1) {
        return [" text-end "];
      } else if (columns === 2) {
        return [" text-end ", " text-end "];
      } else if (columns === 3)
        return [" text-end ", " text-end ", " text-end "];
      else if (columns === 4) {
        return [" text-end ", " text-end ", " text-end ", " text-end "];
      } else {
        return [" text-end ", " text-end ", " text-end ", " text-end ", " text-end ",];
      }

    case "center":
      if (columns === 1) {
        return [" text-center "];
      } else if (columns === 2) {
        return [" text-center ", " text-center "];
      } else if (columns === 3)
        return [" text-center ", " text-center ", " text-center "];
      else if (columns === 4) {
        return [" text-center ", " text-center ", " text-center ", " text-center ",];
      } else {
        return [" text-center ", " text-center ", " text-center ", " text-center ", " text-center ",];
      }      
    default:
      if (columns === 1) {
        return [" text-end "];
      } else if (columns === 2) {
        return [" text-end ", " text-start "];
      } else if (columns === 3)
        return [" text-end ", " text-center ", " text-start "];
      else if (columns === 4) {
        return [" text-end ", " text-end ", " text-start ", " text-start "];
      } else {
        return [" text-end ", " text-end ", " text-center ", " text-start ", " text-start ",];
      }
  }
};

const getPadding = (textAlignment, noOfCols, colIdx, gutter) => {
  gutter = gutter;
  let pl = 0;
  let pr = 0;
  if (textAlignment === "gutter") {
    if (noOfCols == 2) {
      if (colIdx == 0) pr = gutter;
      if (colIdx == 1) pl = gutter;
    }
    if (noOfCols == 4) {
      if (colIdx == 1) pr = gutter;
      if (colIdx == 2) pl = gutter;
    }
  }

  return {
    paddingLeft: `${pl}px`,
    paddingRight: `${pr}px`,
  };
};

// function css(element, style) {
//   for (const property in style) element.style[property] = style[property];
// }


const setBullets = (items, fontStyle, options, idx, bulletClass, bulletAlignJSON) => {
  let bulletParent = document.getElementById("list" + idx);
  if (bulletParent) bulletParent.innerHTML = "";


  let currentRowHeight = 0;

  items.forEach((object, index) => {
    let oldHeight = bulletParent.offsetHeight;

    // Create a wrapper div and append it to the parent
    const wrapperDiv = document.createElement('div');
    wrapperDiv.className = "grid grid-flow-col items-center justify-center";
    wrapperDiv.id = "newBullet"

    // Create the p element
    const pElement = document.createElement('p');
    pElement.className = "m-0 p-0 ";  
    pElement.style.fontFamily = fontStyle.nameOnlyStyle.fontFamily;
    pElement.style.fontSize = `${fontStyle.nameOnlyStyle.fontSize}px`;
    pElement.textContent = object.name;

    // Create the span element
    const spanElement = document.createElement('span');
    spanElement.className = `bullet ${bulletClass} `;

    // Append p and span to the wrapper div
    wrapperDiv.appendChild(pElement);
    wrapperDiv.appendChild(spanElement);

    // Append the wrapper div to the parent
    bulletParent.appendChild(wrapperDiv);

    // Log the current state of the bulletParent
    // console.log('Current bulletParent HTML:', bulletParent.innerHTML);

    let newHeight = bulletParent.offsetHeight;

    // Check if a new row has started
    if (newHeight > oldHeight) {
      const allSpans = bulletParent.querySelectorAll(`span.bullet`);
      // console.log('New row detected. Total spans:', allSpans.length);

      // Remove bullet from the last item of the previous row
      if (allSpans.length > 1) {
        allSpans[allSpans.length - 2].classList.add("rmNewClassbullets");
        // console.log('Removed bullet from previous row item:', allSpans[allSpans.length - 2]);
      }

      // Remove bullet from the first item of the current row
      allSpans[allSpans.length - 1].classList.add("newClassbullets");
      // console.log('Removed bullet from current row item:', allSpans[allSpans.length - 1]);

      currentRowHeight = newHeight;
    }
  });

  // Remove bullet from the last item
  const allSpans = bulletParent.querySelectorAll(`span.bullet`);
  if (allSpans.length > 0) {
    allSpans[allSpans.length - 1].classList.add("rmNewClassbullets");
    // console.log('Removed bullet from last item:', allSpans[allSpans.length - 1]);
  }

  // Align the children properly
  const allItems = bulletParent.querySelectorAll("p");
  allItems.forEach(item => {
    item.style.textAlign = bulletAlignJSON[options.text_alignment] || "left";
  });
};



export default function NameOnly2({ items, options, fontStyle, settings, idx }) {
  const newItems = [];
  items.map((it) => { if (it.name) newItems.push(it) });
  items = newItems;
  // console.log('items = ', items);
  const [...itemsCopy] = items;

  const sortedItems =
    options.column_order === null
      ? itemsCopy
      : options.column_order === "ascending" ? itemsCopy.sort((a, b) => a?.name?.localeCompare(b?.name)) : itemsCopy.sort((a, b) => b?.name?.localeCompare(a?.name));

  const arraySplitData = options.column_flow === "vertical" ? splitArray(sortedItems, options)?.ans : horizontalSplit(sortedItems, options)?.ans;

  const textAlignment = getAlignment(options?.text_alignment, options?.columns);
  
  const bulletAlignJSON = { left: "start", right: "end", center: "center" };

  const [bulletClass, setBulletClass] = useState('');

  useEffect(() => {
    if (options.bullets) {
      setBullets(items, fontStyle, options, idx, bulletClass, bulletAlignJSON);
    }
  });

  useEffect(() => {
    const bulletClasses = {
      'circle': 'circle',
      'square': 'li-square',
      'diamond': 'diamond',
      'lineVertical': 'lineVertical',
      'cross': 'cross'
    };

    if (options.bullets !== null && options.bullets && bulletClasses[options.bullets]) {
      setBulletClass(bulletClasses[options.bullets]);
    }
  }, [options.bullets]);

  return options?.bullets ? (
    <div className="flex flex-col justify-center w-full ">
      <div id={"list" + idx} className={" pl-[1rem] m-auto flex flex-wrap justify-" + bulletAlignJSON[options.text_alignment]}
        style={{ ...fontStyle?.nameOnlyStyle, width: options.column_width + "%",  }}>
      </div>
    </div>
  ) : (
    <div className={`flex flex-row flex-wrap ${options?.columns === 1 ? "justify-center" : ""} ${options?.text_alignment === "gutter" ? "justify-center" : ""}`}
      style={{ width: `${options.column_width * options.columns}%`, margin: "0 auto", wordBreak: 'break-word' }}>
      {arraySplitData.map((items, index) => (
        <div key={index} className={`flex flex-col flex-1 break-words float-left`}
          style={{ ...getPadding(options.text_alignment, arraySplitData.length, index, settings.gutter) }}>
          {items.map((item, idx) => (
            <p key={idx} className={`${textAlignment[index]}`} style={{ ...fontStyle?.nameOnlyStyle, lineHeight: fontStyle?.nameOnlyStyle.lineHeight }}>
              {item.name}
            </p>
          ))}
        </div>
      ))}
    </div>
  );
}
